import { Typography } from "@mui/material";
import { tss } from "tss-react";
import commonStyles, { primarySelectedColor } from "styles/common";

const useStyles = tss.create((theme: any) => ({
    root: {
        position: "relative",
        display: "flex",
        backgroundColor: theme.palette.background.paper,
        borderRadius: 4,
        flexDirection: "column",
    },
    header: {
        fontWeight: 700,
        height: 40,
        width: "100%",
        borderRadius: "4px 4px 0 0",
    },
}));

export default function ModalDialog({
    children = <span />,
    height = "max-content",
    title = "New Dialog",
    width = "max-content",
    headerBackgroundColor = primarySelectedColor,
    style = {},
}) {
    const { classes, cx } = useStyles();
    const { classes: common } = commonStyles();

    return (
        <div
            style={{
                position: "fixed",
                zIndex: 1300,
                inset: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
        >
            <div
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div className={classes.root} style={{ ...style, width: width, height: height }}>
                    <div
                        className={cx(common.middleCenter, classes.header)}
                        style={{ background: headerBackgroundColor }}
                    >
                        <Typography>{title}</Typography>
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}
